import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux'; 
import qs from 'qs';
import styled from 'styled-components';
import server from 'server/serverController2';

import CommentItem from 'components/containers/comment/list/CommentItem';
import BottomTextArea from 'components/containers/input/BottomTextArea';
import { removeItem } from 'utils/utils';
export default function CommentList({type, scrollRef,
									listType,
									targetNo,// This is taskNo(or postNo )
									 commentNo, loadNext , setLoadNext, replyInitCnt=2, limit=20 ,
									 onReplyInserted, onReplyDeleted, onReplyUpdated, onUpdateComment,onDeleteComment
									}) {
	const itemTopRef = useRef(null);
	const itemBottomRef = useRef(null);
  const userInfo = useSelector((state) => {
      return state.userInfo
  })

  const updatedComment = useSelector((state) => {
      return state.commentInfo
  })

	const [commentList, setCommentList] = useState([]);
	const [insertedCommentList, setInsertedCommentList] = useState([])
	const [lastPosNo, setLastPosNo] = useState(null);
	const [isInserting, setIsInserting] = useState(false);
	const [isEnd, setIsEnd] = useState(false);
	const [isLoading, setIsLoading] = useState(false); 

	const [commentContent, setCommentContent] = useState('');
    const [currBottomInputHeight, setCurrBottomInputHeight] = useState(70);
    const [bottomInputFocus, setBottomInputFocus] = useState(false);

	let getCommnetsEndPoint, createCommentEndPoint;
	if(targetNo)
	{
		if(type === 'campaign_post')
		{
			getCommnetsEndPoint =  `campaigns/posts/${targetNo}/comments`;
			createCommentEndPoint=`campaigns/posts/${targetNo}/comments`
		}  
	}

	//internal load
	useEffect(()=>{
		loadComment();
		return function cleanup(){

		}
	},[])

	//externalLoad
	useEffect(()=>{
		if(loadNext===true && setLoadNext)
		{
			loadComment();
			setLoadNext(false);
		}

	},[loadNext])

	const loadComment = () => {
		if(getCommnetsEndPoint && (!isLoading && !isEnd))
		{
			setIsLoading(true);
			let queryString = {}
			if(commentNo)
			{
				queryString['no'] = commentNo;
			}
			
			queryString['last_pos_no'] = lastPosNo;
			queryString['replay_limit'] = replyInitCnt
			queryString['limit'] = limit;
			queryString['get_total_like'] = true;
			queryString['get_total_reply'] = true;
			queryString['show_comment_reply'] = true;
			queryString = qs.stringify(queryString);
			server.getRequestData(`${getCommnetsEndPoint}?${queryString}`, (res)=>{
				try
				{
					const resData = res.data;
					const receivedComment = resData['comments'];

					if(receivedComment.length > 0)
					{
						setCommentList([...commentList, ...receivedComment])
						setLastPosNo(receivedComment[receivedComment.length - 1]['no']);
						let newInsertedCommentList = [...insertedCommentList];
						//if comment is in insertedList -> remove item from insertedList
						for(let i = 0; i < receivedComment.length; ++i)
						{
							const targetComment = receivedComment[i];
							for(let j = 0; j < newInsertedCommentList.length; ++j)
							{
								const targetInserted = newInsertedCommentList[j]
								if(parseInt(targetInserted['no']) === parseInt(targetComment['no']))
								{

									newInsertedCommentList = removeItem(newInsertedCommentList, j)
								}
							}
						}
						setInsertedCommentList(newInsertedCommentList)
					}
					else
					{
						setIsEnd(true);
					}
					setIsLoading(false);
				}
				catch(err)
				{
					setIsLoading(false);
					console.log(err);
				}
			})
		}
	}
	const submitComment = () => {
		if(createCommentEndPoint && isInserting === false)
		{
			setIsInserting(true)
			let form = {}
			form['content'] = commentContent; 
			server.postRequestData(`${createCommentEndPoint}`,form ,(res)=>{
				try
				{
					setIsInserting(false)
					const resData = res.data;
					const insertedComment = resData['inserted_item']; 
					insertedComment['nickname'] = userInfo['name'];
					insertedComment['profile_img'] = userInfo['profile_img'];
					insertedComment['total_comment'] = 0;
					insertedComment['liked_comment'] = false;
					insertedComment['total_like'] = 0;
					setInsertedCommentList([insertedComment,...insertedCommentList])
					setCommentContent('');
					if(scrollRef?.current)
					{
						const bottom = scrollRef?.current.scrollHeight - scrollRef?.current.scrollTop - 100 <= scrollRef?.current.clientHeight;
						if(bottom)
						{
							//moveTobottom
							setTimeout(()=>{
								itemBottomRef.current.scrollIntoView({behavior : 'smooth'})
							},500) 
						}
						else{
							//movetoitem
							itemTopRef.current.scrollIntoView({behavior : 'smooth'});
						}
						
					}
					else{
						itemTopRef.current.scrollIntoView();	
					}
					
				}
				catch(err)
				{
					setIsInserting(false)
					console.log(err);
				}
			})
		}
	}
	const handleDeleteComment = (deletedItem) => {
		if(onDeleteComment)
		{
			onDeleteComment(deletedItem)
		}
		let newCommentList = [...commentList]
		let newInsertedCommentList = [...insertedCommentList]
		let isDeleted = false;
		for(let i = 0; i < newCommentList.length; ++i)
		{
			if(parseInt(newCommentList[i]['no']) === parseInt(deletedItem['no']))
			{
				isDeleted = true; 
				newCommentList = removeItem(newCommentList, i)
			}
		}
		if(isDeleted)
		{ 
			setCommentList(newCommentList);
		}

		isDeleted = false;
		for(let i = 0; i < newInsertedCommentList.length; ++i)
		{
			if(parseInt(newInsertedCommentList[i]['no']) === parseInt(deletedItem['no']))
			{
				isDeleted = true; 
				newInsertedCommentList = removeItem(newInsertedCommentList, i)
			}
		}
		if(isDeleted)
		{ 
			setInsertedCommentList(newInsertedCommentList);
		}
	}
	const handleUpdateComment = (updatedItem) => { 
		if(onUpdateComment)
		{
			onUpdateComment(updatedItem)
		}
		const newCommentList = [...commentList]
		const newInsertedCommentList = [...insertedCommentList]
		let isUpdated = false;
		for(let i = 0; i < newCommentList.length; ++i)
		{
			if(parseInt(newCommentList[i]['no']) === parseInt(updatedItem['no']))
			{
				isUpdated = true;
				newCommentList[i] = {
					...newCommentList[i],
					...updatedItem
				}
			}
		}
		if(isUpdated)
		{
			setCommentList(newCommentList);
		}

		isUpdated = false;
		for(let i = 0; i < newInsertedCommentList.length; ++i)
		{
			if(parseInt(newInsertedCommentList[i]['no']) === parseInt(updatedItem['no']))
			{
				isUpdated = true;
				newInsertedCommentList[i] = {
					...newInsertedCommentList[i],
					...updatedItem
				}
			}
		}
		if(isUpdated)
		{
			setInsertedCommentList(newInsertedCommentList);
		}
	}
	const handleUpdateInitReply = (updatedItem) => {
		//comment List
		const newCommentList = [...commentList]; 
		let isModified = false;
		for(let i = 0; i < newCommentList.length; ++i)
		{
			let initReplyList = newCommentList.children;
			if(initReplyList)
			{
				for(let j = 0; j < initReplyList.length; ++j)
				{
					if(parseInt(updatedItem['no']) === parseInt(initReplyList[j]['no']))
					{
						initReplyList[j] = {
							...initReplyList[j],
							...updatedItem
						}
						isModified = true;
					}
				}	
			}
			if(isModified)
			{
				newCommentList[i]['children'] = initReplyList
			}
		}
		if(isModified)
		{
			setCommentList(newCommentList);
		}


		const newInsertedCommentList = [...insertedCommentList]
		isModified = false;
		for(let i = 0; i < newInsertedCommentList.length; ++i)
		{
			let initReplyList = newInsertedCommentList.children;
			if(initReplyList)
			{
				for(let j = 0; j < initReplyList.length; ++j)
				{
					if(parseInt(updatedItem['no']) === parseInt(initReplyList[j]['no']))
					{
						initReplyList[j] = {
							...initReplyList[j],
							...updatedItem
						}
						isModified = true;
					}
				}	
			}
			if(isModified)
			{
				newInsertedCommentList[i]['children'] = initReplyList
			}
		}
		if(isModified)
		{
			setInsertedCommentList(newInsertedCommentList);
		}
	}
	return (
		<div>
			<div ref={itemTopRef}></div>
			{
				insertedCommentList.map((comment)=>{
					return( 
						<CommentItem 
							key={`comment-inserted-item-no-${comment['no']}`}
							listType={listType}
							listItemType={`${(listType==='comment_list')?'comment_list_item':'reply_list_parent'}`}
							targetNo={targetNo}
							wrapperStyle={{marginBottom : `calc(100vw*(14/375))`}}
							comment={comment}
							type={type}
							onReplyInserted={(insertedItem)=>{if(onReplyInserted)onReplyInserted(insertedItem)}} 
							onReplyDeleted={(deletedItem)=>{if(onReplyDeleted)onReplyDeleted(deletedItem)}}
							onReplyUpdated={(updatedItem)=>{
								if(onReplyUpdated)
								{
									onReplyUpdated(updatedItem)
								}
								//check commentChild
								handleUpdateInitReply(updatedItem);
							}}
							onDeleteComment={handleDeleteComment}
							onUpdateComment={handleUpdateComment}
						/> 
					)

				})
			}
			{commentList.map((comment)=>{
				return( 
					<CommentItem 
						key={`comment-item-no-${comment['no']}`}
						listType={listType}
						listItemType={`${(listType==='comment_list')?'comment_list_item':'reply_list_parent'}`}
						targetNo={targetNo}
						wrapperStyle={{marginBottom : `calc(100vw*(14/375))`}}
						comment={comment}
						type={type}
						onReplyInserted={(insertedItem)=>{if(onReplyInserted)onReplyInserted(insertedItem)}} 
						onReplyDeleted={(deletedItem)=>{if(onReplyDeleted)onReplyDeleted(deletedItem)}}
						onReplyUpdated={(updatedItem)=>{
								if(onReplyUpdated)
								{
									onReplyUpdated(updatedItem)
								}
								//check commentChild
								handleUpdateInitReply(updatedItem);
							}}
						onDeleteComment={handleDeleteComment}
						onUpdateComment={handleUpdateComment}
					/> 
				)

			})}
			{
				((listType === 'comment_list')&& (
					<>
						<Spacer currHeight={currBottomInputHeight} />
						<BottomTextArea 
						maxRow={5} minRow={1}
						onChange={(value) => {setCommentContent(value)}}
						onSubmit={submitComment} 
						textAreaStyle={{lineHeight: '20px', color: 'black'}} 
						onHeightChange={(height) => {
							setCurrBottomInputHeight(height);
						}}
						bottomInputFocus={bottomInputFocus}
						setBottomInputFocus={setBottomInputFocus}
						/>
					</>
				))
			}
			<div ref={itemBottomRef}></div>
		</div>
	);
}

const Spacer = styled.div`
  height: ${({currHeight}) => currHeight && `${currHeight}`}px;
  min-height: ${({currHeight}) => currHeight && `${currHeight}`}px;
  margin-top: calc(100vw * (35 / 375));
`;